var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "app-page-title"
  }, [_c('div', {
    staticClass: "page-title-wrapper"
  }, [_c('div', {
    staticClass: "page-title-heading"
  }, [_vm.icon.length > 0 ? _c('div', {
    staticClass: "page-title-icon"
  }, [_c('i', {
    staticClass: "icon-gradient bg-midnight-bloom",
    class: _vm.icon
  })]) : _vm._e(), _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _c('small', {
    staticClass: "d-block"
  }, [_vm._t("subTitle")], 2)])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }